/**
 * Tiny SVG sparkline — no external deps. Renders a smoothed line + area for a small
 * series of numbers. Used by the Winners card in the Batch Generator.
 */
export default function Sparkline({ values = [], width = 120, height = 28,
                                    stroke = "currentColor", fill = "currentColor",
                                    fillOpacity = 0.12, strokeWidth = 1.5,
                                    "data-testid": testId }) {
  if (!values.length) {
    return <svg width={width} height={height} data-testid={testId} />;
  }
  const min = Math.min(...values);
  const max = Math.max(...values);
  const range = max - min || 1;
  const stepX = values.length > 1 ? width / (values.length - 1) : 0;
  const points = values.map((v, i) => {
    const x = i * stepX;
    const y = height - ((v - min) / range) * (height - 4) - 2;
    return [x, y];
  });
  const linePath = points.map(([x, y], i) => `${i === 0 ? "M" : "L"}${x.toFixed(1)},${y.toFixed(1)}`).join(" ");
  const areaPath = `${linePath} L${(points.at(-1)[0]).toFixed(1)},${height} L0,${height} Z`;
  const last = points.at(-1);
  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} data-testid={testId}
         style={{ overflow: "visible" }}>
      <path d={areaPath} fill={fill} fillOpacity={fillOpacity} stroke="none" />
      <path d={linePath} fill="none" stroke={stroke} strokeWidth={strokeWidth}
            strokeLinecap="round" strokeLinejoin="round" />
      <circle cx={last[0]} cy={last[1]} r={2.5} fill={stroke} />
    </svg>
  );
}
